import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/app/lp/bike-insurance/BikeInsurancePageClient.tsx");
